import { render, staticRenderFns } from "./SimilarList.vue?vue&type=template&id=d0c58768&scoped=true&"
import script from "./SimilarList.vue?vue&type=script&lang=js&"
export * from "./SimilarList.vue?vue&type=script&lang=js&"
import style0 from "./SimilarList.vue?vue&type=style&index=0&id=d0c58768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c58768",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
